import { Component, ViewChild } from '@angular/core';
import { ReportPage } from '../report/report';
import { AppointmentPage } from '../appointment/appointment';
import { ExChartPage } from '../ex-chart/ex-chart';
import { TestChartPage } from '../test-chart/test-chart';
import { Globals } from '../../services/globals';
import { MatTabChangeEvent } from '@angular/material';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  templateUrl: './common-layout.html',
  styleUrls: ['./common-layout.scss'],
})

export class CommonLayout {
  /**
   * 레포트 페이지
   */
  @ViewChild(ReportPage) report: ReportPage;

  /**
   * 예약 페이지
   */
  @ViewChild(AppointmentPage) appointment: AppointmentPage;

  /**
   * 운동 차트 페이지
   */
  @ViewChild(ExChartPage) exChart: ExChartPage;

  /**
   * 검사 페이지
   */
  @ViewChild(TestChartPage) testChart: TestChartPage;

  /**
   * 페이지 제목
   */
  pageTitle: string = 'BB리포트';

  /**
   * 선택한 탭 인덱스 저장
   */
  tabIndex: number | string = 0;

  /**
   * Globals
   */
  private g: Globals;

  /**
   * @constructor
   */
  constructor(
    private $g: Globals,
    private $local: LocalStorageService) {
    // 저장된 인덱스가 있다면 뒤로 가기했을때 보던 탭으로 이동하도록 설정
    this.tabIndex = $local.getTabIndex() || 0;
  }

  /**
   * 현재 선택된 아동의 개별 여부
   */
  isIndividual(): boolean {
    return this.$g.child.level === 5;
  }

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.pageTitle = tabChangeEvent.tab.textLabel;
    const i = tabChangeEvent.index;
    this.$local.setTabIndex(i);
    i === 0 ?
      this.report.viewEnter() : i === 1 ?
      this.appointment.viewEnter() : i === 2 ?
      this.exChart.viewEnter() : this.testChart.viewEnter();
  }
}
